import { httpClient } from '../_helpers'
import { IOutstandingBooking, IUser, IVerifyToken } from '../interfaces/app.interface';
import { corpBaseUrl } from '../constants/appConstant';


export const authService = {
  login,
  logout,
  me,
  currentAgent,
  register,
  requestResetPassword,
  resetPassword,
  confirmResetPasswordCode,
  verifyEmail,
  getOutstandingBookings,
  verifyToken,
  refreshToken,
  verifyCode,
};

/**
 * login by user/pass
 * @returns
 */
async function login(username: string, password: string) {
  return httpClient.post(`${corpBaseUrl}corporate/login`, { username, password })
}

async function logout() {
  localStorage.clear();
}

async function currentAgent() {
  const { data } = await httpClient.get(`${corpBaseUrl}corporate/current-user`)
  return data;
}

async function getOutstandingBookings() {
  return httpClient.get<IOutstandingBooking[]>(`${corpBaseUrl}auth/outstanding-bookings`);
}

async function register(data: any) {
  return httpClient.post(`${corpBaseUrl}auth/register`, data);
}

async function requestResetPassword(data: any) {
  return httpClient.post(`${corpBaseUrl}corporate/request-reset-password`, data);
}

async function confirmResetPasswordCode(data: any) {
  return httpClient.post(`${corpBaseUrl}auth/confirm-reset-password-code`, data);
}

async function resetPassword(data: any) {
  return httpClient.post(`${corpBaseUrl}corporate/set-password`, data);
}

async function verifyCode(data: any) {
  return httpClient.post(`${corpBaseUrl}corporate/verify-code`, data);
}

async function verifyEmail(data: any) {
  return httpClient.post(`${corpBaseUrl}auth/verify-email`, data);
}

async function refreshToken(refresh_token: string) {
  return httpClient.get(`${corpBaseUrl}auth/refresh`, {
    headers: {
      refreshToken: refresh_token
    }
  });
}

/**
 * login by token
 * @returns
 */
async function verifyToken(data: IVerifyToken) {
  return httpClient.post(`${corpBaseUrl}auth/verify-token`, data)
}

async function me() {
  return httpClient.get<IUser>(`${corpBaseUrl}auth/me`);
}